export default {
  pickAColor: 'Izberite barvo',
  color: 'Barva',
  alerts: {
    uniqueNameError: 'Kategorija z istim imenom že obstaja.'
  }
};
